export default "__VITE_ASSET__BdcdhtDW__"